<template>
  <div>
    <v-dialog v-model="viewDocument" max-width="900" height="100vh" class="pdf_manual">
      <v-card height="100vh">
        <vue-pdf-app :file="pdf" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VuePdfApp from "./pdfViewApp.vue";
export default {
  props: ["filename"],
  components: {
    "vue-pdf-app": VuePdfApp
  },

  data() {
    return {
      viewDocument: false,
      pdfReadyLoading: false,
      pdf: "",
      currentFile: ""
    };
  },

  methods: {
    // PDF
    base64ToArrayBuffer(base64) {
      var binary_string = window.atob(base64);
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      this.pdf = bytes.buffer;
      this.viewDocument = true;
      this.$emit("openPdf", { state: false });
      return bytes.buffer;
    },

    // PDF
    viewManual(nameVal) {
      // this.$emit("openPdf", { state: true });
      axios
        .get("/common/get_pdf", {
          params: {
            name: nameVal
          }
        })
        .then(res => {
          this.base64ToArrayBuffer(res.data);
        })
        .catch(error => {
          this.$emit("openPdf", { state: false });
          console.error("errrr found", error);
        });
    },

    // doesFileExist
    doesFileExist(url) {
      // console.log("doesFileExist run");
      return fetch(url)
        .then(response => {
          if (response.ok) {
            // File exists
            return true;
          } else {
            // File does not exist
            return false;
          }
        })
        .catch(error => {
          // An error occurred, file may not exist or other network issue
          console.error("Error:", error);
          return false;
        });
    }
  },

  // mounted() {
  //   if (this.filename) {
  //     this.viewManual(this.filename);
  //   }
  // },

  created() {
    console.log("Common PDF View component run");
    this.doesFileExist(this.filename).then(exists => {
      if (!exists) {
        Swal.fire({
          title: "Sorry!",
          text: "File does not exists."
        }).then(result => {
          this.viewDocument = false;
          this.$emit("openPdf", { state: false });
        });
      } else {
        console.log("else");
        if (this.filename) {
          this.viewManual(this.filename);
        }
      }
    });
  }
};
</script>

<style scoped>
.pdf_manual {
  position: absolute;
  z-index: 9999;
}
</style>